module.exports = __webpack_public_path__ + "img/empty-icon.641997ae.png";